import flattenDeep from "lodash/flattenDeep";

import { PartWithChildrenDto } from "#modules/parts/infra/fetchPartWithChildren.api";

export const findChild = (
  id: string | undefined,
  part: PartWithChildrenDto,
): PartWithChildrenDto | null => {
  if (!id) {
    return null;
  }
  if (id === part.id) {
    return part;
  }

  const children = part.children.map((child) => {
    return findChild(id, child as PartWithChildrenDto);
  });

  const flattenChildren = flattenDeep(children);

  return flattenChildren.find((child) => child?.id === id) ?? null;
};
